function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import { FormattedMessage } from 'react-intl';
import App, { AlertsBus } from 'modules/App';
import { useAction } from 'hooks/useAction';
import Form from 'components/Form';
import Button from 'components/Form/Button';
import CodeFormPartial from 'components/CodeFormPartial';
import { useProgressFailed } from 'hooks';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import { useOtpLockoutDuration } from '../../../hooks';
import { VERIFY_EMAIL_FORM, OTP_LENGTH } from '../../../constants';
import { OtpLockInfo, OtpResendBtn } from '../../../partials/OTP';
import validatorRules from './validatorRules.json';
import styles from './verifyCode.pcss';
const Header = ({ email })=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("header", {
                className: "pageHeader",
                children: /*#__PURE__*/ _jsx("h1", {
                    className: "text--h2 align-items-center text-align--center",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.enterCode))
                })
            }),
            /*#__PURE__*/ _jsx(AlertsBus, {
                className: "mb-6"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mb-5 text-align--center",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.confirmAccountViaOTP), {
                    values: {
                        email: /*#__PURE__*/ _jsx("b", {
                            className: styles.email,
                            children: email
                        })
                    }
                }))
            })
        ]
    });
const VerifyCode = ({ email })=>{
    var _formValues_values;
    useStyles(styles);
    const otpStatus = useSelector(selectors.otpStatus);
    const isOTPInProgress = useSelector(selectors.isOTPInProgress);
    const hasErrors = useSelector(selectors.hasOtpErrors);
    const formValues = useSelector(App.selectors.formSelector(VERIFY_EMAIL_FORM));
    const verifyOtp = useAction(actions.verifyOtp);
    const clearErrors = useAction(actions.clearErrors);
    const setFormValue = useAction(App.actions.setFormValue, VERIFY_EMAIL_FORM);
    const clearForm = useAction(App.actions.clearForm, VERIFY_EMAIL_FORM);
    const confirmEmailCancel = useAction(actions.confirmEmailCancel);
    const unsetInactiveIdentity = useAction(actions.unsetInactiveIdentity);
    const [isInProgress, setIsInProgress] = useState(false);
    const lockoutDuration = useOtpLockoutDuration(otpStatus);
    const isDisabled = isInProgress;
    const submitForm = ({ otp })=>{
        setIsInProgress(true);
        verifyOtp(otp);
    };
    const processForm = App.hooks.useFormProcessing(VERIFY_EMAIL_FORM, submitForm);
    const onSubmit = ()=>{
        processForm(formValues, validatorRules);
    };
    const className = styles.root;
    const otp = formValues === null || formValues === void 0 ? void 0 : (_formValues_values = formValues.values) === null || _formValues_values === void 0 ? void 0 : _formValues_values.otp;
    const isOtp = !!otp && otp.length === OTP_LENGTH;
    useProgressFailed(isOTPInProgress, hasErrors, clearForm);
    useEffect(()=>()=>{
            clearErrors();
            confirmEmailCancel();
        }, []);
    useEffect(()=>{
        if (hasErrors) {
            setIsInProgress(false);
        }
    }, [
        hasErrors
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(Header, {
                email: email
            }),
            /*#__PURE__*/ _jsxs(Form, {
                onSubmit: onSubmit,
                className: className,
                children: [
                    /*#__PURE__*/ _jsx(OtpLockInfo, {
                        lockoutDuration: lockoutDuration,
                        hasErrors: hasErrors
                    }),
                    /*#__PURE__*/ _jsx(CodeFormPartial, {
                        id: "otp",
                        codeLength: OTP_LENGTH,
                        isDisabled: isDisabled,
                        onSetFormValue: setFormValue
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "row flex-column-reverse flex-sm-row",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-12 col-sm-6",
                                children: /*#__PURE__*/ _jsx(OtpResendBtn, {
                                    lockoutDuration: lockoutDuration
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-12 col-sm-6",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    type: "submit",
                                    styleModifier: "primary",
                                    labelMessage: App.messages.buttons.continue,
                                    className: "btn--block btn--filled",
                                    isDisabled: !isOtp,
                                    isInProgress: isInProgress
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-flex justify-content-center mt-4",
                        children: /*#__PURE__*/ _jsx("a", {
                            "aria-hidden": "true",
                            onClick: unsetInactiveIdentity,
                            className: "text--primary",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.changeEmail))
                        })
                    })
                ]
            })
        ]
    });
};
export default VerifyCode;
